$prefix: studyflix-embed--;

.#{$prefix}iframe {
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.#{$prefix}iframe-container {
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  overflow: hidden;
}

.#{$prefix}embed-container {
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 5px;
}

.#{$prefix}video-backlink {
  width: 100%;
  display: flex;
  align-items: center;
  height: 42px;
  font-size: 14px;
  overflow: hidden;
  font-family: 'Noto Sans', 'Segoe UI', 'Arial', sans-serif;
  color: white;
  background-color: #2b2b2b;
  &,
  &:visited,
  &:focus,
  &:hover {
    text-decoration: none;
    color: white;
  }
}

.#{$prefix}video-backlink--play-logo {
  flex: 0 0 auto;
  margin: 0 10px 0 14px;
  height: 16px;
  width: 16px;
  background-image: url('frontend/shared/images/icons/play-white.svg?inline');
  background-size: 16px 16px;
}

.#{$prefix}video-backlink--title {
  flex: 0 1 auto;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  .#{$prefix}video-backlink:hover & {
    text-decoration: underline;
  }
}

.#{$prefix}video-backlink--duration {
  flex: 0 0 auto;
  opacity: 0.6;
  margin: 0 2em 0 0.5em;
}

.#{$prefix}video-backlink--logo {
  flex: 0 0 auto;
  height: 24px;
  width: 89px;
  margin: 5px 12px 5px auto;
  background-image: url('shared/images/logo.svg?inline');
  background-size: 89px 24px;
}
